// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QWfLD","left":"styles_left__27WSQ"};